import { cn } from './cn';

/**
 * Full-bleed Work canvas background — the surface every artifact panel, the
 * landing and the session pane paint, and the one every card on Work sits on.
 *
 * `bg-surface-container` in both themes. The Work canvas is an inset container,
 * just a very large one: the chrome around it is the page, and the canvas is the
 * panel inset into it. The DS surface ladder types `surface-container` as "inset
 * container fill", which is the role this plays.
 *
 * Open with the design-system team as DS-1850, because the ladder has no rung
 * for an inset at this scale and two effects are deliberate rather than settled:
 * under `newBrandDark` the container (#1f1f1f) is lighter than the cards on it
 * (`surface`, neutral/900) so cards read recessed rather than proud, and under
 * `newBrand` it sits a point off the white cards. Take either to DS-1850 rather
 * than reaching back for `surface-page`.
 *
 * This was `bg-surface-shell` under the DS-882 inset flag, which resolves to
 * `surface` in light themes and `surface-page` in dark — so dark mode had
 * separation and light mode painted the canvas the exact white of the cards.
 * Naming the tone directly makes the two themes agree.
 */
export function workCanvasSurfaceClassName(...extra: Parameters<typeof cn>): string {
  return cn('bg-surface-container', ...extra);
}
